var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookReadLine = function SvgBookReadLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3.5 4.794a.9.9 0 0 1 .893-.894h16.214c.493 0 .893.4.893.894v14.413a.9.9 0 0 1-.893.893H4.393a.893.893 0 0 1-.893-.893zm8.1.906H5.3v12.6h6.3zm1.8 0v12.6h6.3V5.7zm.9 1.8h4.5v1.8h-4.5zm0 2.7h4.5V12h-4.5z"
  })));
};
export default SvgBookReadLine;